'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildEmailMetadata;

var _immutable = require('immutable');

var _EmailMessageMetadata = require('../records/EmailMessageMetadata');

var _EmailMessageMetadata2 = _interopRequireDefault(_EmailMessageMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildEmailMetadata() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _EmailMessageMetadata2.default)((0, _immutable.fromJS)(props));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/email-message-metadata/operators/buildEmailMetadata.js
// module id = 731
// module chunks = 2 3